import { Routes, Roles } from '../constants';

export function isRouteVisible(route, role) {
  switch (route.path) {
    case Routes.TEAM.path:
      return [Roles.SUPER_ADMIN].includes(role);
    case Routes.REPORTS.path:
      return [Roles.SUPER_ADMIN].includes(role);
    case Routes.WORKFLOW.path:
      return [Roles.SUPER_ADMIN, Roles.CS_ADMIN].includes(role);
    case Routes.COMPANIES.path:
      return [Roles.SUPER_ADMIN].includes(role);
    case Routes.COMPANY.path:
      return [Roles.ADMIN].includes(role);
    case Routes.TEMPLATE.path:
      return [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.CS_ADMIN, Roles.MANAGER].includes(role);
    case Routes.DASHBOARD.path:
    default:
      return true;
  }
}

export function isRouteActive(route, currentPage) {
  const { path, paths } = route;

  switch (path) {
    case Routes.TEAM.path:
      return currentPage.includes('team');
    case Routes.REPORTS.path:
      return currentPage.includes('reports');
    case Routes.WORKFLOW.path:
      return currentPage.includes('workflow');
    case Routes.TEMPLATE.path:
      return currentPage === Routes.TEMPLATE.path;
    case Routes.COMPANY.path:
      return currentPage === Routes.COMPANY.path;
    case Routes.COMPANIES.path:
      return [Routes.COMPANY.path, Routes.COMPANIES.path].includes(currentPage);
    case Routes.DASHBOARD.path:
      return paths?.includes(currentPage) || currentPage?.includes('tenant');
    default:
      return false;
  }
}
